import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import "../../assets/css/events.css";

const ASSETS = "/assets";

const EMPTY_FORM = { name: "", company: "", designation: "", phone: "", email: "" };

const THEMES = [
  { n: "01", title: "Formats & IP", body: "Owning the idea — registering, protecting and licensing a format across languages and markets." },
  { n: "02", title: "Unscripted economics", body: "Reality and factual at scale — what really drives the cost, and where the margin actually sits." },
  { n: "03", title: "Scripted pipelines", body: "From writers' room to greenlight — building a development slate that platforms keep saying yes to." },
  { n: "04", title: "Co-productions", body: "Structuring partnerships that actually ship — rights, risk and revenue between houses and platforms." },
  { n: "05", title: "Streaming & windows", body: "Platforms, rights and release strategy — how windowing decisions shape the value of a format." },
  { n: "06", title: "Pitch & packaging", body: "Selling a format that travels — the deck, the bible and the room where the deal gets done." },
];

const AUDIENCE = [
  "Production Houses", "Film Studios", "Line Producers", "Executive Producers",
  "Writers", "Content Distributors", "Heads of Content", "Heads of Acquisition",
  "Format Acquisition", "Chief Content Officers",
];

const MARQUEE = "Formats & IP / Unscripted economics / Scripted pipelines / Co-productions / Streaming & windows / Pitch & packaging / ";

const CALENDAR_URL =
  "https://calendar.google.com/calendar/render?action=TEMPLATE" +
  "&text=The%20Production%20Circle%20%26%20Formats" +
  "&dates=20260723T043000Z/20260723T113000Z" +
  "&details=An%20invitation-only%20seminar%20on%20the%20business%20of%20formats.%20Joining%20details%20to%20follow%20by%20email." +
  "&location=Mumbai";

export default function ProductionCircle({
  logoSrc = ASSETS + "/orasi-logo.png",
  seatsUrgency = true,
  onSubmit,
}) {
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY_FORM);
  const [fieldErrors, setFieldErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [config, setConfig] = useState({});

  let img = window.app?.img;
  useEffect(() => {
    if (window.site) setConfig(window.site);
  }, []);
  if (config?.common?.imagesCDN) img = config.common.imagesCDN;

  useEffect(() => {
    const anyOpen = showDuplicateModal;
    if (anyOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.overflowY = "scroll";
    } else {
      const top = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflowY = "";
      if (top) window.scrollTo(0, -parseInt(top, 10));
    }
    return () => {
      const top = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflowY = "";
      if (top) window.scrollTo(0, -parseInt(top, 10));
    };
  }, [showDuplicateModal]);

  const bannerUrl = `${img}orasi/client/resources/orasiv1/images/banner.jpg`;
  const heroStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.15) 46%, rgba(0,0,0,0.92) 100%), url('${bannerUrl}')`,
  };

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const clearFieldError = (key) => setFieldErrors((prev) => { const n = { ...prev }; delete n[key]; return n; });

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.name.trim())    errs.name    = "Name is required.";
    if (!form.company.trim()) errs.company = "Company is required.";
    if (!form.email.trim())   errs.email   = "Email is required.";
    if (Object.keys(errs).length) {
      setFieldErrors(errs);
      setTimeout(() => setFieldErrors({}), 3000);
      return;
    }
    setFieldErrors({});
    setSubmitting(true);
    const { lambda, appname: appName } = window.app;
    try {
      const response = await axios.post(
        `${lambda}/eventregister?appname=${appName}`,
        { appname: appName, ...form }
      );
      const data = response.data;
      const innerStatus = data?.statusCode ?? response.status;
      const msg = (data?.message || data?.body || data?.result || "").toLowerCase();
      if (innerStatus === 409 || msg.includes("already") || msg.includes("exist")) {
        setShowDuplicateModal(true);
      } else {
        if (onSubmit) onSubmit({ ...form });
        navigate("/thank-you", { state: { ...form } });
      }
    } catch (err) {
      const status = err?.response?.status;
      const msg = (err?.response?.data?.message || err?.response?.data?.body || "").toLowerCase();
      if (status === 409 || msg.includes("already") || msg.includes("exist")) {
        setShowDuplicateModal(true);
      } else {
        setFieldErrors({ _api: "Something went wrong. Please try again." });
        setTimeout(() => setFieldErrors({}), 3000);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pc-root" id="top">

      {/* HEADER */}
      <header className="pc-header">
        <a href="#top" className="pc-logo-link">
          <img
            src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
            alt="Orasi Logo"
            className="pc-logo-img"
          />
        </a>
        <nav className="pc-nav">
          <a className="pc-nav-link" href="#about">About</a>
          <a className="pc-nav-link" href="#themes">Formats</a>
          <a className="pc-btn-amber" href="#book">Register</a>
        </nav>
      </header>

      {/* HERO + BOOKING FORM */}
      <section className="pc-hero" style={heroStyle}>
        <div className="pc-hero-inner">
          <div className="pc-hero-left">
            <div className="pc-eyebrow">An invitation-only showcase · 2026</div>
            <h1 className="pc-h1">
              The Production Circle <span className="pc-amber-text">&amp; Formats</span>
            </h1>
            <p className="pc-hero-sub">
              Two ideas, one room — The Production Circle, the AI-powered platform that runs every
              stage of production, and Formats, the proven concepts licensed and adapted across
              markets, languages and platforms.
            </p>
            <div className="pc-fact-row">
              <div className="pc-fact-item">
                <div className="pc-fact-label">Date</div>
                <div className="pc-fact-value">29th July 2026</div>
              </div>
              <div className="pc-fact-item--mid">
                <div className="pc-fact-label">Time</div>
                <div className="pc-fact-value">7:00 PM onwards followed by dinner &amp; cocktail</div>
              </div>
              <div className="pc-fact-item--last">
                <div className="pc-fact-label">Venue</div>
                <div className="pc-fact-value">Kino Cottage, Versova<br/> 63, J.P Road, Seven Bungalows,<br/> Versova, Andheri West, Mumbai,<br/> Maharashtra 400061</div>
              </div>
            </div>
          </div>

          <div id="book" className="pc-card">
            <div className="pc-card-eyebrow">Request your seat</div>
            <h2 className="pc-card-title">Eighty seats. By request.</h2>
            <p className="pc-card-sub">We confirm guests on a rolling basis. Early requests get priority.</p>

            {seatsUrgency && (
              <div className="pc-urgency">
                <span className="pc-urgency-dot" />
                <span className="pc-urgency-text">Limited release — under 30 seats remaining</span>
              </div>
            )}

            <form onSubmit={submit}>
              <div className="pc-form-grid">
                <label className="pc-form-row-full">
                  <span className="pc-field-label">Name *</span>
                  <input
                    className={`pc-input${fieldErrors.name ? " pc-input--error" : ""}`}
                    value={form.name}
                    onChange={(e) => { update("name")(e); clearFieldError("name"); }}
                    placeholder="Your full name"
                  />
                  {fieldErrors.name && <span className="pc-field-error">{fieldErrors.name}</span>}
                </label>
                <label className="pc-form-row-full">
                  <span className="pc-field-label">Company *</span>
                  <input
                    className={`pc-input${fieldErrors.company ? " pc-input--error" : ""}`}
                    value={form.company}
                    onChange={(e) => { update("company")(e); clearFieldError("company"); }}
                    placeholder="Production house"
                  />
                  {fieldErrors.company && <span className="pc-field-error">{fieldErrors.company}</span>}
                </label>
                <label className="pc-form-row-half">
                  <span className="pc-field-label">Designation</span>
                  <input
                    className="pc-input"
                    value={form.designation}
                    onChange={update("designation")}
                    placeholder="e.g. Head of Production"
                  />
                </label>
                <label className="pc-form-row-half">
                  <span className="pc-field-label">Phone</span>
                  <input
                    className="pc-input"
                    value={form.phone}
                    onChange={update("phone")}
                    placeholder="+91"
                  />
                </label>
                <label className="pc-form-row-full">
                  <span className="pc-field-label">Email *</span>
                  <input
                    className={`pc-input${fieldErrors.email ? " pc-input--error" : ""}`}
                    value={form.email}
                    onChange={(e) => { update("email")(e); clearFieldError("email"); }}
                    type="email"
                    placeholder="you@studio.com"
                  />
                  {fieldErrors.email && <span className="pc-field-error">{fieldErrors.email}</span>}
                </label>
              </div>

              {fieldErrors._api && <div className="pc-api-error">{fieldErrors._api}</div>}

              <button type="submit" className="pc-submit" disabled={submitting}>
                {submitting ? (
                  <>
                    <span className="pc-spinner" />
                    Submitting…
                  </>
                ) : (
                  <>Reserve your seat <span className="pc-arrow">→</span></>
                )}
              </button>
              <p className="pc-form-note">
                We'll only use these details to confirm your seat. No spam.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* ALREADY REGISTERED MODAL */}
      {showDuplicateModal && (
        <div className="pc-modal-overlay" onClick={() => setShowDuplicateModal(false)}>
          <div className="pc-modal-box--dup" onClick={(e) => e.stopPropagation()}>
            <button className="pc-close" onClick={() => setShowDuplicateModal(false)} aria-label="Close">×</button>
            <div className="pc-modal-icon--dup">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#F2B233" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <div className="pc-modal-badge pc-modal-badge--amber">Already registered</div>
            <h3 className="pc-modal-title--dup">You're already on the list.</h3>
            <p className="pc-modal-body--dup">
              We already have a request from{" "}
              <span className="pc-modal-highlight">{form.email || "this email"}</span>. Our team
              will be in touch to confirm your seat.
            </p>
            <button className="pc-btn-got-it" onClick={() => setShowDuplicateModal(false)}>
              Got it
            </button>
          </div>
        </div>
       )}

      {/* MARQUEE */}
      <div className="pc-marq-wrap">
        <div className="pc-marq-track">
          {[0, 1].map((i) => (
            <span key={i} className="pc-marq-item">
              {MARQUEE.split("/").map((part, j, arr) => (
                <React.Fragment key={j}>
                  {part}
                  {j < arr.length - 1 && <span className="pc-marq-sep">/</span>}
                </React.Fragment>
              ))}
            </span>
          ))}
        </div>
      </div>

      {/* ABOUT — TWO PILLARS */}
      <section id="about" className="pc-section">
        <div className="pc-inner">
          <div className="pc-about-intro">
            <div className="pc-kicker">
              <span className="pc-dot" />
              <span className="pc-kicker-text">Two pillars, one day</span>
            </div>
            <h2 className="pc-about-h2">
              The platform that runs production, and the formats worth producing.
            </h2>
          </div>
          <div className="pc-pillars-grid">
            <div className="pc-pillar">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#F2B233" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="pc-pillar-icon">
                <circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3.2" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
              </svg>
              <h3 className="pc-pillar-h3">The Production Circle</h3>
              <p className="pc-pillar-body">
                An AI-powered production management platform that simplifies and streamlines every
                stage of the production lifecycle — from pre-production planning and script
                breakdowns to scheduling, collaboration, asset management and production tracking.
              </p>
              <p className="pc-pillar-body-dim">
                It brings people, projects and workflow together in one place, cutting manual effort
                and improving collaboration from concept to delivery — built for producers, studios,
                broadcasters, agencies and content creators.
              </p>
            </div>
            <div className="pc-pillar">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#F2B233" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="pc-pillar-icon">
                <rect x="2.5" y="6" width="19" height="13" rx="2" />
                <path d="M7 6V4.5a1.5 1.5 0 0 1 1.5-1.5h7A1.5 1.5 0 0 1 17 4.5V6" />
                <path d="M10 11.5v3l3-1.5-3-1.5z" fill="#F2B233" stroke="none" />
              </svg>
              <h3 className="pc-pillar-h3">Formats</h3>
              <p className="pc-pillar-body">
                Proven television and digital entertainment concepts that can be licensed and
                adapted for local audiences across countries and languages — scripted or unscripted,
                game shows, reality, talent competitions, factual entertainment and lifestyle programs.
              </p>
              <p className="pc-pillar-body-dim">
                Format licensing lets broadcasters, producers and streaming platforms recreate
                successful shows while keeping the original creative framework and brand identity intact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THEMES */}
      <section id="themes" className="pc-section-alt">
        <div className="pc-inner">
          <div className="pc-themes-header">
            <h2 className="pc-themes-h2">What we'll get into</h2>
            <p className="pc-themes-sub">
              Six threads run through the day — each anchored by a panel and a working session.
            </p>
          </div>
          <div className="pc-themes-grid">
            {THEMES.map((t) => (
              <div key={t.n} className="pc-theme">
                <div className="pc-theme-num">{t.n}</div>
                <h3 className="pc-theme-title">{t.title}</h3>
                <p className="pc-theme-body">{t.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHO IT'S FOR */}
      <section className="pc-who">
        <div className="pc-who-grid">
          <div>
            <div className="pc-kicker">
              <span className="pc-dot" />
              <span className="pc-kicker-text">Who it's for</span>
            </div>
            <h2 className="pc-who-h2">Built for the decision-makers.</h2>
            <p className="pc-who-body">
              If you green-light, develop, package, acquire or license content, this room is yours.
              We keep it senior and we keep it small.
            </p>
          </div>
          <div className="pc-who-tags">
            {AUDIENCE.map((a) => (
              <span key={a} className="pc-tag">{a}</span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA STRIP */}
      <section className="pc-cta">
        <div className="pc-inner--md">
          <h2 className="pc-cta-h2">A seat in the Circle is by request.</h2>
          <p className="pc-cta-body">
            Full-day access, lunch &amp; networking, and the post-event format toolkit — included
            for every confirmed guest.
          </p>
          <a className="pc-cta-btn" href="#book">
            Reserve your seat <span className="pc-cta-arrow">→</span>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="pc-footer">
        <div className="pc-footer-inner">
          <div className="pc-footer-grid">
            <div>
              <img
            src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
            alt="Orasi Logo"
            className="pc-logo-img"
          />
              <p className="pc-footer-tagline">
                The Production Circle — a closed-door seminar on formats, IP and the business of
                Indian production. Mumbai, 2026.
              </p>
            </div>
            <div>
              <div className="pc-footer-col-title">Event</div>
              <div className="pc-footer-col-content">
                29th July 2026<br />
                7:00 PM onwards followed by dinner & cocktail<br />
                Kino Cottage, Versova
              </div>
            </div>
            <div>
              <div className="pc-footer-col-title">Contact</div>
              <div className="pc-footer-col-content">
                info@orasimedia.com<br />
                +1 (201) 633 8748<br />
                <a href="#book" className="pc-footer-link">Request a seat →</a>
              </div>
            </div>
            <div>
              <div className="pc-footer-col-title">Social</div>
              <a
                href="https://www.linkedin.com/company/orasimedia"
                target="_blank"
                rel="noopener noreferrer"
                className="pc-footer-linkedin"
                aria-label="Orasi Media on LinkedIn"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                Follow us on LinkedIn
              </a>
            </div>
          </div>
          <div className="pc-footer-bottom">
            <span className="pc-footer-copy">© 2026 Orasi Media · The Production Circle.</span>
            <span className="pc-footer-copy">An invitation-only seminar · Mumbai</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
